import { http } from '@/utils/axios'

// 获取机构列表（下拉框）
export function getSchoolList(data) {
    return http({
        url: http.baseUrl('statistics/getSchoolList'),
        method: 'get',
        params: http.params(data)
    })
}

// 获取总量统计
export function getTotalCount(data) {
    return http({
        url: http.baseUrl('statistics/totalCount'),
        method: 'post',
        data: http.data(data)
    })
}

// 开始总量统计
export function getTotalCounts(data) {
  return http({
      url: http.baseUrl('statistics/totalCount'),
      method: 'get',
      params: http.data(data)
  })
}

// 获取总量统计列表
export function getTotalList(data) {
    return http({
        url: http.baseUrl('statistics/totalList'),
        method: 'get',
        params: http.data(data)
    })
}

// 班级课程统计
export function getAlbumTotalCount(data) {
    return http({
        url: http.baseUrl('statistics/albumTotalCount'),
        method: 'get',
        params: http.data(data)
    })
}

// 班级课程-助学专业统计列表
export function getAlbumMajorList(data) {
    return http({
        url: http.baseUrl(`statistics/albumMajorList`),
        method: 'get',
        params: http.data(data)
    })
}

// 班级课程-助学专业统计列表-点击专业名称列表
export function getMajorAlbumList(data) {
  return http({
      url: http.baseUrl(`statistics/majorAlbumList`),
      method: 'get',
      params: http.data(data)
  })
}

// 班级课程-合作院校统计列表
export function getAlbumSchoolList(data) {
    return http({
        url: http.baseUrl(`statistics/albumSchoolList`),
        method: 'get',
        params: http.data(data)
    })
}

// 班级课程-合作机构统计列表
export function getAlbumMhmList(data) {
    return http({
        url: http.baseUrl('statistics/albumMhmList'),
        method: 'get',
        params: http.data(data)
    })
}

// 点播课程-资源统计
export function getCourseTotalCount(data) {
  return http({
      url: http.baseUrl('statistics/courseTotalCount'),
      method: 'get',
      params: http.data(data)
  })
}

// 点播课程-课程目录统计列表
export function getBaseCourseList(data) {
    return http({
        url: http.baseUrl('statistics/baseCourseList'),
        method: 'get',
        params: http.data(data)
    })
}

// 点播课程-课程资源统计列表
export function getCourseList(data) {
    return http({
        url: http.baseUrl('statistics/courseList'),
        method: 'get',
        params: http.data(data)
    })
}

// 点播课程-开课总数统计列表
export function getBatchList(data) {
  return http({
      url: http.baseUrl('statistics/batchList'),
      method: 'get',
      params: http.data(data)
  })
}

// 点播课程-课程资源成绩占比
export function getRatioByBatchId(data) {
  return http({
      url: http.baseUrl('statistics/getRatioByBatchId'),
      method: 'get',
      params: http.data(data)
  })
}
// 资源统计
export function resourcesStatisticsList(data) {
  return http({
      url: http.baseUrl('zkolResourcesStatistics/resourcesStatisticsList'),
      method: 'get',
      params: http.data(data)
  })
}
